import {
  EmptyPageComponent,
  PaginationComponent,
  SynDialogConfig,
} from '$synapse/core';
import { Group, Page } from '$synapse/models';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { GroupCreationModalComponent } from './group-creation-modal/group-creation-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { SHARED_IMPORTS } from '../../core/shared-imports';

@Component({
  selector: 'syn-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss'],
  imports: [SHARED_IMPORTS, EmptyPageComponent, PaginationComponent],
})
export class GroupsComponent implements OnInit {
  private readonly _route = inject(ActivatedRoute);
  private readonly _router = inject(Router);
  private readonly _modalDialog = inject(MatDialog);

  searchTerm: string = '';
  filteredGroups: Group[] = [];

  readonly page$: Observable<Page<Group>> = this._route.data.pipe(
    map((data) => data['page'])
  );

  ngOnInit(): void {
    this.page$.subscribe((page) => {
      this.filteredGroups = page.content;
    });
  }

  createGroup() {
    const dialogRef = this._modalDialog.open(
      GroupCreationModalComponent,
      new SynDialogConfig('group-creation-modal-component')
    );
    dialogRef.afterClosed().subscribe(() => {
      this._router.navigateByUrl('/groups');
    });
  }

  filterGroups(): void {
    this.page$.subscribe((page) => {
      this.filteredGroups = page.content.filter((group) =>
        group.name.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    });
  }
}
